import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const OrderRequestedBadge = (props: BadgeProps): React.ReactElement => {
  return (
    <Badge
      {...props}
      icon={"TIMER_SAND_EMPTY"}
      className={twMerge("bg-yellow-100 text-yellow-800", props.className)}
    >
      Order requested
    </Badge>
  );
};
